import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import { withStyles } from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import DoubleButton from '../../../popup/components/DoubleButton';
import TextInput from 'components/TextInput';
import * as Yup from 'yup';
import validationShema from 'constants/ValidationShema';
import useId from 'hooks/useId';
import { connect } from 'react-redux'
import RepoService from 'services/RepoService';
import InputLimits from "constants/InputLimits";

const style = theme => ({
	padding: {
		marginTop: theme.spacing(2)
	}
})

function CreateFolderPopup({
	open,
	onClose,
	classes,
	formSubmit,
	demandId
}) {

	const formId = useId();

	const handleSubmit = () => formSubmit[formId]()
	const onAdd = (values) => {
		RepoService.addFolder(demandId,values)
		onClose()
	}

	return (
		<Dialog
			title={Tr('create_folder')}
			open={open}
			maxWidth={'md'}
		>
			<Form
				initialValues={{
					name: "",
					description: ""
				}}
				validationSchema={Yup.object().shape({
					name: validationShema.stringMax(InputLimits.procedure.documents.NAME),
				})}
				onSubmit={onAdd}
				id={formId}
			>
				{(formikProps) => (
					<GridBlock column>
						<TextInput
							id='name'
							formikProps={formikProps}
							label={Tr('folder_name')}
							required
							limit={InputLimits.procedure.documents.NAME}
						/>
						<TextInput
							id='description'
							formikProps={formikProps}
							label={Tr('folder_description')}
							multiline
						/>

						<div className={classes.actions}>
							<DoubleButton
								justify='flex-end'
								labelFirst={Tr('cancel')}
								labelSecond={Tr('add')}
								onClickFirst={onClose}
								onClickSecond={handleSubmit}
							/>
						</div>
					</GridBlock>
				)}
			</Form>
		</Dialog>
	)
}

export default connect((state) => ({
	formSubmit: state.form
}), {})(withStyles(style)(CreateFolderPopup));